import complaintsPersonalForm from './complaints-personal-form/complaints-personal-form.vue';
import store from '../../../common/js/vuex/store';
import { mapGetters } from 'vuex';
import { ROUTE_NAMES } from '../constants/complaint-constants';

export default {
	components: {
		complaintsPersonalForm
	},
	computed: {
		...mapGetters('complaints', ['lastVisitedPage', 'visitedPages'])
	},
	beforeRouteLeave(to, from, next) {
		let isPageTheLastVisited = this.lastVisitedPage == from.path;
		let toPathIsValid = store.state.complaints.validPages.indexOf(to.path) > -1;
		if (this.$refs['complaints-personal-form'].isFormInvalid()) {
			store.dispatch('complaints/removeValidPages', from.path);
			if (!isPageTheLastVisited || !toPathIsValid) {
				this.$refs['complaints-personal-form'].jumpToFirstError();
				next(false);
			} else {
				next();
			}
		} else {
			store.dispatch('complaints/addValidPages', from.path);
			this.$refs['complaints-personal-form'].submit().then(
				() => {
					next();
				},
				() => {
					next(false);
				}
			);
		}
	},
	beforeRouteEnter(to, from, next) {
		if (to.path == ROUTE_NAMES.PROBLEM || store.state.complaints.validPages.indexOf(from.path) != -1 || from.path == ROUTE_NAMES.SUMMARY) {
			store.dispatch('complaints/addVisitedPage', to.path);
			store.dispatch('complaints/setCurrentPage', to.path);
			next();
		} else {
			next(ROUTE_NAMES.PROBLEM);
		}
	}
};
